export default __webpack_public_path__ + "static/media/humanity.e7c8b649.jpg";